import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'

// hooks
import { useWindowSize } from '@navent-jobs/ui-kit/hooks/window-size'

// components
import Metas from './components/metas'
import Breadcrumbs from './components/breadcrumbs'
import BusquedasRelacionadas from './components/busquedas-relacionadas'
import FichaAviso from './components/ficha-aviso'

// mixins
import { PageContent } from './mixins'

const Page = ({ match, error }) => {
  const history = useHistory()
  const { isTabletLandscape, isDesktop } = useWindowSize()
  const isDesktopOrTabletLandscape = isDesktop || isTabletLandscape

  useEffect(() => {
    if (error) {
      history.push(`/${error}`)
    }
  }, [error])

  return (
    <PageContent>
      <Metas />

      {isDesktopOrTabletLandscape && <Breadcrumbs />}

      <FichaAviso match={match} />

      {!isDesktopOrTabletLandscape && <Breadcrumbs />}

      <BusquedasRelacionadas />
    </PageContent>
  )
}

export default Page
